import { authRoutes } from '../features/auth/routes';

export const routes = [...authRoutes];
